export const CosignatureStatusEnum = {
  PENDING: "pending",
  REJECTED: "rejected",
  RESUBMITTED: "resubmitted",
  SIGNED: "signed",
} as const;

export const CosignatureRequirementReasonEnum = {
  LMSW: "LMSW",
  Other: "Other",
} as const;

export const CosignatureDocumentTypeEnum = {
  note: "note",
  note_addendum: "note_addendum",
} as const;
